export function buildDataset(hangers) {
  const data = []
  for (const h of hangers) {
    for (let i = 0; i < h.weightCount; i++) data.push(h.value)
  }
  return data
}

export function mean(data) {
  if (!data.length) return 0
  const sum = data.reduce((a, b) => a + b, 0)
  return sum / data.length
}